export default class Cart {
  constructor() {
    this.cartForm = document.querySelector('.js-cart-form');
    this.body = document.body;
    this.cartTimeout = null;

    if (this.cartForm) {
      Cart.init();
    }

    if (window.location.hostname === 'shop.coavacoffee.com') {
      Cart.updateCartCount();
    }

    document.querySelectorAll('.js-qty').forEach(input => {
      Cart.updateButtonStates(input);
    });

    document.querySelectorAll('.js-qty_adjust').forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const input = Cart.adjustQuantity(event.currentTarget);
        const updateBtn = document.querySelector('.js-cart_update');
        if (updateBtn) updateBtn.classList.add('cart-update--changed');
        Cart.syncPrice(input);
      });
    });
  }

  static updateCartNote(note) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: `note=${note}`,
    })
      .then(response => response.json())
      .then(() => {
        console.log(`Cart note updated to ${note}`);
      })
      .catch((error) => {
        console.log(`Cart note error ${error}. Not updated to ${note}`);
      })
      .finally(() => {
        console.log('Done trying to update cart note.');
      });
  }

  static init() {
    document.body.addEventListener('change', (event) => {
      if (event.target.matches('textarea[name="note"]')) {
        Cart.updateCartNote(event.target.value);
      }
    });
  }

  static adjustQuantity(element) {
    const qtySelector = element.parentNode.querySelector('.js-qty');

    let qty = parseInt(qtySelector.value.replace(/\D/g, ''), 10);
    qty = Cart.validateQty(qty);

    const min = parseInt(qtySelector.getAttribute('min'), 10) || 1;
    const max = parseInt(qtySelector.getAttribute('max'), 10) || 99;

    if (element.classList.contains('js-qty_adjust--increase')) {
      if (qty < max) qty += 1;
    } else {
      if (qty > min) qty -= 1;
    }

    qtySelector.value = qty;
    Cart.updateButtonStates(qtySelector);
    return qtySelector;
  }

  static updateButtonStates(input) {
    const min = parseInt(input.getAttribute('min'), 10) || 1;
    const max = parseInt(input.getAttribute('max'), 10) || 99;
    const qty = parseInt(input.value, 10);
    const container = input.parentNode;
    const decrease = container.querySelector('.js-qty_adjust--decrease');
    const increase = container.querySelector('.js-qty_adjust--increase');
    if (decrease) {
      decrease.style.opacity = qty <= min ? '0.35' : '';
      decrease.style.pointerEvents = qty <= min ? 'none' : '';
    }
    if (increase) {
      increase.style.opacity = qty >= max ? '0.35' : '';
      increase.style.pointerEvents = qty >= max ? 'none' : '';
    }
  }

  static validateQty(qty) {
    if (parseFloat(qty) === parseInt(qty, 10) && !Number.isNaN(qty)) {
      return qty;
    }
    return 1;
  }

  static syncPrice(input) {
    const row = input.closest('[data-item-key]');
    if (!row) return;

    const key = row.getAttribute('data-item-key');
    const unitPrice = parseInt(row.getAttribute('data-item-price'), 10);
    const qty = parseInt(input.value, 10);

    if (!isNaN(unitPrice) && !isNaN(qty)) {
      const subtotalEl = document.querySelector(`.js-line-subtotal[data-key="${key}"]`);
      if (subtotalEl) subtotalEl.textContent = Cart.formatMoney(unitPrice * qty);
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: { [key]: qty } }),
    })
      .then(r => r.json())
      .then(cart => {
        const totalEl = document.querySelector('.js-cart-total');
        if (totalEl) totalEl.textContent = Cart.formatMoney(cart.total_price);

        const grandTotalEl = document.querySelector('.js-cart-grand-total');
        if (grandTotalEl) grandTotalEl.textContent = Cart.formatMoney(cart.total_price);
      })
      .catch(() => {});
  }

  static formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return '$' + (dollars.endsWith('.00') ? dollars.slice(0, -3) : dollars);
  }

  static updateCartCount() {
    const cartCount = document.querySelector('.js-cart_count');

    fetch('/cart.json')
      .then(response => response.json())
      .then(data => {
        const itemCount = data.item_count;
        if (itemCount > 0) {
          cartCount.textContent = itemCount;
        }
      });
  }
}
